import * as React from 'react';
import { SvgProps } from './SvgGetter/SvgGetter.tsx';
import { Colors } from '../../../styles/colors.ts';

export const KartPin: React.FC<SvgProps> = ({ fill = Colors.primaryTekst, opacity, ...props }) => {
	return (
		<svg
			width='32'
			height='32'
			viewBox='0 0 32 32'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15.2189 29.8525C15.4138 30.0801 15.6923 30.2223 15.9987 30.2223C16.3051 30.2223 16.5836 30.0801 16.7785 29.8525C17.7811 28.6863 26.6654 18.3325 26.6654 12.6721C26.6654 6.67028 21.8751 1.77783 15.9987 1.77783C10.1223 1.77783 5.33203 6.67028 5.33203 12.6721C5.33203 18.3524 14.1896 28.6552 15.2143 29.8472L15.2189 29.8525ZM10.6497 12.8144C10.6497 15.8295 13.0449 18.2758 15.997 18.2758C18.9491 18.2758 21.3442 15.8295 21.3442 12.8144C21.3442 9.79931 18.9491 7.35309 15.997 7.35309C13.0449 7.35309 10.6497 9.79931 10.6497 12.8144ZM12.7664 12.8144C12.7664 10.994 14.2146 9.51487 15.997 9.51487C17.7794 9.51487 19.2276 10.994 19.2276 12.8144C19.2276 14.6349 17.7794 16.114 15.997 16.114C14.2146 16.114 12.7664 14.6349 12.7664 12.8144Z'
				fill={fill}
			/>
		</svg>
	);
};
